<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-4">
                Keagenan - Lokasi Agen
              </h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
          <CButtonGroup>
            <CButton color="secondary" @click="handleChooseStatus(1)"
              >POS</CButton
            >
            <CButton color="secondary" @click="handleChooseStatus(2)"
              >Consol</CButton
            >
          </CButtonGroup>
        </CCardHeader>
        <table-pos v-if="status === 'POS'"></table-pos>
        <table-consol v-if="status === 'Consol'"></table-consol>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Vue from "vue";
import jwt from "jsonwebtoken";
import tablePOS from "./tables/Pos";
import tableConsol from "./tables/Consol";

Vue.component("table-pos", tablePOS);
Vue.component("table-consol", tableConsol);

export default {
  name: "Network",
  data() {
    return {
      status: "POS",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleChooseStatus(event) {
      if (event === 1) {
        this.status = "POS";
      } else if (event === 2) {
        this.status = "Consol";
      }
    },
  },
};
</script>
